import { connect } from 'react-redux';
import { MediaGallery, MediaGalleryProps } from '../components/MediaGallery';
import { State } from '../core/reducers';

const mapStateToProps = (state: State, props: MediaGalleryProps) => ({
  userId: state.sdk.userId,
  displayName: state.calls.callAgent?.displayName,
  remoteParticipants: state.calls.remoteParticipants,
  dominantParticipants: state.calls.dominantParticipants,
  localVideoStream: state.streams.localVideoStream,
  selectedPane: props.selectedPane,
});

const connector: any = connect(mapStateToProps);
export default connector(MediaGallery);
